import type { EventInput } from '../../../server/queries/utils/crm-event-build-input.ts';
import { api } from '../../../utils/api.ts';

type UpdateEventVariables = { eventId: string; data: EventInput };

type UseUpdateEventOptions = {
    onSuccess?: (
        data: {
            success: boolean;
            event_id: string;
            message: string;
        },
        variables: UpdateEventVariables,
    ) => void;
    onError?: (message?: string) => void;
};

export function useUpdateEvent(options: UseUpdateEventOptions = {}) {
    const apiUtils = api.useUtils();

    const updateEventMutation = api.platoUser.command.events.update.useMutation({
        onError(error) {
            options.onError?.(error instanceof Error ? error.message : String(error));
        },
        onSuccess(data, variables) {
            if (variables.eventId) {
                void apiUtils.platoUser.query.events.getEventById.invalidate({
                    eventId: variables.eventId,
                });
            }
            void apiUtils.platoUser.query.customerActivity.getFeedList.withFilters.invalidate();
            void apiUtils.platoUser.query.events.getList.invalidate();
            void apiUtils.platoUser.query.events.getUpcomingCustomerEvents.invalidate();
            options.onSuccess?.(data, variables);
        },
    });

    return updateEventMutation;
}
